import resourceReducer from './';

export default resourceReducer;
